import React from 'react';

export default function ServiceFAQ({ faqs }) {
  return (
    <section className="mt-10" aria-labelledby="service-faq-title">
      <h2 id="service-faq-title" className="text-2xl font-bold">Common questions</h2>
      <div className="mt-5 space-y-5">
        {faqs.map(({ q, a }) => <div key={q} className="rounded-xl border border-border bg-card p-5"><h3 className="font-semibold">{q}</h3><p className="mt-2 text-muted-foreground leading-relaxed">{a}</p></div>)}
      </div>
    </section>
  );
}